module.exports = __webpack_public_path__ + "static/media/students1.571d9b80.png";